import { lensApi } from "@/services/lensApi";
import { getStructureFilterParamsForRequst, StructureFilterParams } from "@/utils/filters";

interface BlockageResponse extends Dryp.ApiList<Dryp.Blockage> {
	itemsMeta: null;
}

export const blockage = {
	getBlockage: async (structureId: Dryp.StructureId): Promise<Dryp.Blockage | null> => {
		const response = await lensApi.get<Dryp.Blockage | null>(`/structure/${structureId}/blockage`);

		return response;
	},
	getAll: async (
		pagination: Dryp.PaginationQuery,
		sort?: Dryp.SortQuery,
		structureFilters?: StructureFilterParams,
		status?: Dryp.BlockageStatus,
	): Promise<BlockageResponse | null> => {
		try {
			const sortDesirialize = sort
				? {
						direction: sort.direction,
						sort: sort.sort.replace("_value", ""),
					}
				: {};
			const response = await lensApi.get<BlockageResponse>(`/blockages`, {
				params: {
					...pagination,
					...sortDesirialize,
					status,
					...getStructureFilterParamsForRequst(structureFilters || {}),
				},
			});

			return response;
		} catch (error) {
			throw error;
		}
	},
};
